import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";
import { crearRequestMercaderiasPiSeun } from "./mercaderiasPiSeun";

export const consultarMercaderias = ({ EmpresaId, iFiltro = 0, filtros = {}, signal }) =>
  _Componentes_WebApiCalls_Post(
    "Combos/MercaderiasPiSeun",
    crearRequestMercaderiasPiSeun(EmpresaId, iFiltro, filtros),
    { signal },
  );

export const listarCatalogoMercaderias = ({ EmpresaId, signal }) =>
  consultarMercaderias({ EmpresaId, filtros: { ListarTodos: true }, signal });
